import { useCallback, useState } from 'react';
import type { NoAgendamientoModalParams } from './noAgendamientoFormSchema';

/**
 * Estado compartido para abrir/cerrar el popup de No Agendamiento desde cualquier punto de
 * entrada (PatientTable, PatientDetailView, MissingNextSessionModal, ReportAbsenceModal).
 * `params` es la fuente de verdad de "está abierto" — null = cerrado.
 */
export function useNoAgendamientoModal() {
  const [params, setParams] = useState<NoAgendamientoModalParams | null>(null);

  const open = useCallback((next: NoAgendamientoModalParams) => setParams(next), []);
  const close = useCallback(() => setParams(null), []);

  return { params, open, close };
}
